import React from "react"
import { generalStyles as gs } from "../styles/styles"
import InputV2 from "../basics/input/InputV2"
import CollapsibleCardV2 from "../basics/interface/CollapsibleCardV2"

const DepFicheClientV2 = ({ dep, updateDep, refs, open, onToggle }) => (
	<CollapsibleCardV2 title="Client" open={open} onToggle={onToggle}>
		<div style={gs.fieldGroup}>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Nom</label>
				<InputV2
					style={gs.input}
					value={dep.nom}
					ref={refs.refNom}
					onFocus={(e) => e.target.select()}
					onChange={(e) => updateDep("nom", e)}
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Prénom</label>
				<InputV2
					style={gs.input}
					value={dep.prenom}
					onFocus={(e) => e.target.select()}
					onChange={(e) => updateDep("prenom", e)}
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Tel</label>
				<InputV2
					style={gs.input}
					value={dep.telephone}
					onFocus={(e) => e.target.select()}
					onChange={(e) => updateDep("telephone", e)}
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>E-mail</label>
				<InputV2
					style={gs.input}
					value={dep.email}
					onFocus={(e) => e.target.select()}
					onChange={(e) => updateDep("email", e)}
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Adresse</label>
				<InputV2
					style={gs.input}
					value={dep.adresse_client_0}
					onFocus={(e) => e.target.select()}
					onChange={(e) => updateDep("adresse_client_0", e)}
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>&nbsp;</label>
				<InputV2
					style={gs.input}
					value={dep.adresse_client_1}
					onFocus={(e) => e.target.select()}
					onChange={(e) => updateDep("adresse_client_1", e)}
					nextRef={refs.refTarifBase}
				/>
			</div>
		</div>
	</CollapsibleCardV2>
)

export default DepFicheClientV2
